import React, {PropsWithChildren, useMemo} from "react";
import {isErrorException, isNetworkError} from "@firefly/fly-http";
import {QueryCache, QueryClient, QueryClientProvider} from "react-query";
import {isFunction} from "../util/base";
import {Modal} from "antd";



export default function AppQueryClientProvider({children}: PropsWithChildren<any>) {

    function showError(result: any) {
        Modal.warn({
            style: {
                top: 260
            },
            title: result.title,
            content: result.subtitle
        });
    }

    const queryClient = useMemo(() => {
        function onError(error: any) {
            if (isErrorException(error)) {
                const {
                    message,
                    error: errorInfo,
                    context,
                } = error;
                const {
                    request,
                    response,
                } = context??{};
                const title = message;
                const subTitle = errorInfo ? `错误代码： ${errorInfo.code}` : undefined;
                showError({
                    title: title,
                    subtitle: subTitle,
                    details: [
                        response && {
                            key: "X-TraceID",
                            value: response?.headers.get("X-TraceID"),
                        },
                        response && {
                            key: "Method",
                            value: request?.method,
                        },
                        request && {
                            key: "URL",
                            value: request?.url,
                        }
                    ].filter(item => item)
                })
            } else if (isNetworkError(error)) {
                showError({
                    title: error.message??"网络错误"
                })
            } else if (typeof error === 'string'){
                showError({
                    title: error as string,
                })
            } else {
                showError({
                    title: "无法识别错误",
                })
            }
        }
        return new QueryClient({
            queryCache: new QueryCache({
                onError: (error, query) => {
                    // if(isAccessDeniedException(error)) {
                    //     //这里不应该invalid 破坏的整体模型
                    //     // securityClient.invalidate();
                    //     return;
                    // }
                    if (isFunction(query.meta?.onError)) {
                        if (query.meta?.onError!(error, query) === false) {
                            return;
                        }
                    }
                    //有订阅表示没throw 则展示异常
                    const hasObserver = ((query as any).observers as any).some((observer: any) => {
                        const {
                            options: {
                                throwOnError
                            }
                        } = observer;
                        if (throwOnError) {
                            if (throwOnError === true) {
                                return false;
                            }
                            return !throwOnError(error, query)
                        }
                        return true;
                    })
                    console.log(`hasObserver:`, hasObserver)

                    if (hasObserver) {
                        onError(error);
                    }

                },
            }),
            defaultOptions: {
                queries: {
                    refetchOnWindowFocus: false,
                    retry: false,
                    // onError: onError,
                },
                mutations: {
                    onError: onError,
                }
            }
        })
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    )
}
